import { Component, input, OnInit, output } from '@angular/core';
import { distinctUntilChanged } from 'rxjs';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslatePipe } from '@ngx-translate/core';
import { NgClass, TitleCasePipe } from '@angular/common';
import { FilterValues } from '@shared/services/admin-contract.service';
import { ConsumptionFilter } from '../../../theme/admin/contracts/contract-invoicing-report/consumption.filter';
import { ConsumptionFilterFactory } from '../../../theme/admin/contracts/contract-invoicing-report/ConsumptionFilter.factory';
import { InvoicingFilters } from '@shared/services/abstract-contract.service';

@Component({
  selector: 'app-contract-filters-actionbar',
  templateUrl: 'contract-filters-actionbar.html',
  imports: [TranslatePipe, NgClass, TitleCasePipe, NgSelectComponent, ReactiveFormsModule],
  standalone: true,
})
export class ContractFiltersActionbar implements OnInit {
  public filterValues = input.required<FilterValues>();
  public display = input<Array<keyof ConsumptionFilter>>(['tags', 'organizations', 'clusters']);
  public disabled = input<Array<keyof ConsumptionFilter>>([]);
  public multiple = input<Array<keyof ConsumptionFilter>>([]);
  public onSelect = output<InvoicingFilters>();

  constructor(public filterFactory: ConsumptionFilterFactory) {
    this.filterFactory.createContractInvoicingFilterFormGroup();
  }

  ngOnInit() {
    if (this.filterFactory.getFormGroup().valid) {
      this.filterFactory
        .getFormGroup()
        .valueChanges.pipe(distinctUntilChanged())
        .subscribe((value) => {
          const { organizations, tags, clusters } = value;
          this.onSelect.emit({ organizationCodes: organizations?.code, tags: tags, clusterUids: clusters?.uid });
        });
    }

    this.disabled().forEach((key: keyof ConsumptionFilter) => this.getFormControl(key).disable());
  }

  public getFormGroup() {
    return this.filterFactory.getFormGroup();
  }

  public setColumns(): `col-${3 | 4 | 6 | 12}` | `col-${3 | 4 | 6 | 12} col-md-${3 | 4 | 6 | 12}` {
    switch (this.display()?.length) {
      case 3:
        return 'col-12 col-md-4';
      case 2:
        return 'col-12 col-md-6';
      case 1:
        return 'col-12';
      default:
        return 'col-12 col-md-3';
    }
  }

  private getFormControl(key: keyof ConsumptionFilter): FormControl<Array<string>> {
    return this.filterFactory.getFormControl(key);
  }

  protected readonly Array = Array;
}
